module.exports = __webpack_public_path__ + "img/fre.c0c53550.jpg";